import React from "react";
import { Box, Typography, Grid, Container } from "@mui/material";
import { motion } from "framer-motion";

const OurStory = () => {
  return (
    <Box
      sx={{
        backgroundColor: "#FFF7F0",
        py: { xs: 8, md: 12 },
        px: { xs: 2, md: 0 },
      }}>
      <Container maxWidth="lg" disableGutters>
        <Typography
          variant="h3"
          fontWeight="bold"
          textAlign="center"
          sx={{
            fontFamily: "Moul",
            position: "relative",
            display: "inline-block",
            mb: { xs: 4, md: 6 },
          }}>
          Our Story
          <Box
            sx={{
              width: "60px",
              height: "4px",
              backgroundColor: "#FF6F61",
              borderRadius: "2px",
              position: "absolute",
              left: "50%",
              bottom: "-12px",
              transform: "translateX(-50%)",
            }}
          />
        </Typography>

        <Grid
          container
          spacing={{ xs: 0, md: 4 }}
          alignItems="center"
          justifyContent="center"
          sx={{ flexDirection: { xs: "column", md: "row" } }}>
          <Grid item xs={12} md={6}>
            <Box sx={{ width: "100%", overflowX: "clip" }}>
              <motion.div
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}>
                <Box
                  component="img"
                  src="/images/our-story.jpg"
                  alt="Anna and Suren baking"
                  sx={{
                    width: "100%",
                    maxWidth: "100%",
                    boxSizing: "border-box",
                    borderRadius: 4,
                    boxShadow: "0 12px 32px rgba(0,0,0,0.1)",
                    border: "4px solid white",
                    objectFit: "cover",
                  }}
                />
              </motion.div>
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box sx={{ width: "100%", overflowX: "clip" }}>
              <motion.div
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8, delay: 0.2 }}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontStyle: "italic",
                    color: "text.secondary",
                    textAlign: { xs: "center", md: "left" },
                    mb: 2,
                  }}>
                  “We’ve never just been about desserts. We’ve always been about
                  people.”
                </Typography>

                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { xs: "1rem", md: "1.2rem" },
                    lineHeight: 1.8,
                    color: "text.primary",
                    textAlign: { xs: "center", md: "left" },
                  }}>
                  What started as a side hustle in a cozy kitchen in 2019 grew
                  into a movement of handmade, heartfelt creations. From one
                  oven to three storefronts and even a vending machine — every
                  cake we make still carries the same care, craftsmanship, and
                  purpose.
                </Typography>

                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { xs: "1rem", md: "1.2rem" },
                    lineHeight: 1.8,
                    color: "text.primary",
                    textAlign: { xs: "center", md: "left" },
                    mt: 2,
                  }}>
                  We’ve never just been about desserts. We’ve always been about
                  people.
                </Typography>

                <Typography
                  variant="body2"
                  sx={{
                    fontFamily: "Dancing Script, cursive",
                    fontSize: "1.4rem",
                    color: "text.secondary",
                    textAlign: { xs: "center", md: "left" },
                    mt: 4,
                  }}>
                  — Anna & Suren
                </Typography>
              </motion.div>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default OurStory;
